import styled, { css } from 'styled-components';

const widthTransition = 'width .2s ease-in';
const borderRadiusMixin = ({
  theme,
  value,
  max
}) => {
  if (value === max) {
    return css(["border-radius:", ";"], theme.progressIndicator.borderRadius);
  }
  return css(["/*! @noflip */ border-radius:", " 0 0 ", ";"], theme.progressIndicator.borderRadius, theme.progressIndicator.borderRadius);
};

/** Separated out due to issues with styled-components not setting rtl styles properly */
const borderRadiusRTLMixin = ({
  theme,
  value,
  max
}) => {
  if (value === max) {
    return css(["border-radius:", ";"], theme.progressIndicator.borderRadius);
  }
  return css(["/*! @noflip */ border-radius:0 ", " ", " 0;"], theme.progressIndicator.borderRadius, theme.progressIndicator.borderRadius);
};
const getColorFromTheme = ({
  theme,
  $status,
  $colorValue
}) => {
  if ($status === 'error') {
    return theme.progressIndicator.colors.error[$colorValue];
  }
  if ($status === 'warning') {
    return theme.progressIndicator.colors.warning[$colorValue];
  }
  return theme.progressIndicator.colors.default[$colorValue];
};
const ProgressContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30037988__sc-1174sv-0"
})(["", ";width:100%;"], ({
  $inline
}) => $inline ? css(["display:flex;align-items:center;flex-direction:row;justify-content:flex-start;gap:10px;"]) : css(["display:block;"]));
const Tick = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30037988__sc-1174sv-1"
})(["position:absolute;width:1px;height:", ";background:", ";left:", "%;inset-inline-start:", "%;right:auto;inset-inline-end:auto;[dir=\"rtl\"] &&{right:", "%;inset-inline-start ", "%;left:auto;inset-inline-end:auto;}", ""], ({
  $size,
  theme
}) => $size === 'small' ? theme.progressIndicator.tickHeightSmall : theme.progressIndicator.tickHeightMini, ({
  theme
}) => theme.progressIndicator.tickBg, ({
  $targetValue
}) => $targetValue, ({
  $targetValue
}) => $targetValue, ({
  $targetValue
}) => $targetValue, ({
  $targetValue
}) => $targetValue, ({
  $size,
  $targetValue,
  $value,
  theme
}) => $value > $targetValue && css(["::before{content:\"\";background:", ";height:", ";position:absolute;right:1px;top:2px;width:2px;}::after{content:\"\";background:", ";height:", ";left:1px;top:2px;position:absolute;width:2px;}"], theme.progressIndicator.bgDefault, $size === 'small' ? theme.progressIndicator.heightSmall : theme.progressIndicator.heightMini, theme.progressIndicator.bgDefault, $size === 'small' ? theme.progressIndicator.heightSmall : theme.progressIndicator.heightMini));
// Note: Firefox does not give a means of styling the <progress> container.
// Currently only webkit supports animations on the progress bar itself.
const Progress = /*#__PURE__*/styled('progress').withConfig({
  componentId: "sc-storm-ui-30037988__sc-1174sv-2"
})(["-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:", ";border:none;border-radius:", ";color:", ";height:", ";width:100%;::-webkit-progress-bar{background:", ";border-radius:", ";@media (prefers-reduced-motion:no-preference){transition:", ";}}::-webkit-progress-value{background:", ";", " @media (prefers-reduced-motion:no-preference){transition:", ";}}::-moz-progress-bar{background:", ";", " @media (prefers-reduced-motion:no-preference){transition:", ";}}/*! @noflip */ [dir=\"rtl\"] &{::-webkit-progress-value{", "}::-moz-progress-bar{", "}}"], ({
  theme
}) => theme.progressIndicator.bgDefault, ({
  theme
}) => theme.progressIndicator.borderRadius, getColorFromTheme, ({
  theme,
  $size
}) => $size === 'small' ? theme.progressIndicator.heightSmall : theme.progressIndicator.heightMini, ({
  theme
}) => theme.progressIndicator.bgDefault, ({
  theme
}) => theme.progressIndicator.borderRadius, widthTransition, getColorFromTheme, borderRadiusMixin, widthTransition, getColorFromTheme, borderRadiusMixin, widthTransition, borderRadiusRTLMixin, borderRadiusRTLMixin);
const Container = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30037988__sc-1174sv-3"
})(["align-items:center;display:flex;position:relative;width:100%;& > ", ":not(:first-child){position:absolute;background-color:transparent;::-webkit-progress-bar{background:transparent;}}"], Progress);

export { Container as C, ProgressContainer as P, Tick as T, Progress as a };
//# sourceMappingURL=ProgressIndicator.styles-40c7a9d5.js.map
